import React from 'react';

/** Wie Entgelt-App, optisch an Portal (Slate + Navy/Coral) bzw. klassische helle Shell angepasst. */
const CTA_HREF = 'https://hrfactory.com/de/germany/kontakt/';

const AVATARS = [
  {
    src: 'https://hrfactory.com/wp-content/uploads/2024/07/Dani-Signatur-150x150.jpg',
    alt: 'Daniel Daser, Account Manager bei HR factory',
  },
  {
    src: 'https://hrfactory.com/wp-content/uploads/2022/01/HR-factory-Moritz-Meyer-2-150x150.jpg',
    alt: 'Moritz Meyer, Senior Account Manager bei HR factory',
  },
  {
    src: 'https://hrfactory.com/wp-content/uploads/2024/07/Christina-Klampfer-150x150.webp',
    alt: 'Christina Klampfer, Business Development Managerin bei HR factory',
  },
  {
    src: 'https://hrfactory.com/wp-content/uploads/2024/11/Anna-Weyand-150x150.jpg',
    alt: 'Anna Weyand bei HR factory',
  },
  {
    src: 'https://hrfactory.com/wp-content/uploads/2023/01/HR-factory-Christiane-Niebler-150x150.jpg',
    alt: 'Christiane Bartsch, Business Development Managerin DACH bei HR factory',
  },
];

function EntgeltBeratungsCta({ variant = 'resources' }) {
  if (variant === 'resources') {
    return (
      <a
        href={CTA_HREF}
        target="_blank"
        rel="noopener noreferrer"
        className="block rounded-xl p-3 bg-white/5 border border-white/10 hover:bg-white/[0.08] transition-colors no-underline"
      >
        <span className="block w-6 h-0.5 rounded-full bg-hrf-coral mb-2.5" aria-hidden />
        <h3 className="text-sm font-bold text-white leading-snug mb-2">Wir beraten dich gern.</h3>
        <div className="flex flex-wrap gap-1.5 mb-2">
          {AVATARS.map((a) => (
            <img
              key={a.src}
              src={a.src}
              alt={a.alt}
              width={32}
              height={32}
              loading="lazy"
              decoding="async"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-8 h-8 rounded-full object-cover object-top border-2 border-white/15 shrink-0 bg-slate-700"
            />
          ))}
        </div>
        <p className="text-[11px] text-slate-400 leading-relaxed m-0">
          Sprich uns an – unsere Account Manager unterstützen dich.
        </p>
      </a>
    );
  }

  return (
    <a
      href={CTA_HREF}
      target="_blank"
      rel="noopener noreferrer"
      className="block rounded-xl p-3 bg-white border border-gray-200 shadow-sm hover:border-hrf-navy/25 hover:shadow transition-all duration-200 ease-out hover:-translate-y-0.5 no-underline"
    >
      <span className="block w-6 h-0.5 rounded-full bg-hrf-coral mb-2.5" aria-hidden />
      <h3 className="text-sm font-bold text-gray-900 leading-snug mb-2">Wir beraten dich gern.</h3>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {AVATARS.map((a) => (
          <img
            key={a.src}
            src={a.src}
            alt={a.alt}
            width={32}
            height={32}
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-8 h-8 rounded-full object-cover object-top border-2 border-gray-200 shrink-0 bg-gray-100"
          />
        ))}
      </div>
      <p className="text-[11px] text-gray-600 leading-relaxed m-0">
        Sprich uns an – unsere Account Manager unterstützen dich.
      </p>
    </a>
  );
}

export default EntgeltBeratungsCta;
